'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
type MessageSkeletonProps = {
  role?: 'user' | 'assistant';
  className?: string;
};
export function MessageSkeleton(t0) {
  const $ = _c(28);
  const {
    role: t1,
    className
  } = t0;
  const role = t1 === undefined ? "assistant" : t1;
  const isUser = role === "user";
  let t2;
  if ($[0] !== className) {
    t2 = cn("group/message min-w-0 w-full", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0
    };
    t4 = {
      opacity: 1
    };
    t5 = {
      opacity: 0
    };
    t6 = {
      duration: 0.2
    };
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== isUser) {
    t7 = cn("flex min-w-0 w-full flex-col gap-4 rounded-md text-[14px]", isUser ? ["bg-muted border border-border", "ml-auto w-fit max-w-[85%] px-2.5 py-2"] : "w-full");
    $[6] = isUser;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = isUser ? "w-48" : "w-full max-w-96";
  let t9;
  if ($[8] !== t8) {
    t9 = cn("h-4 rounded", t8);
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t9) {
    t10 = <Skeleton className={t9} />;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = isUser ? "w-36" : "w-full max-w-80";
  let t12;
  if ($[12] !== t11) {
    t12 = cn("h-4 rounded", t11);
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t12) {
    t13 = <Skeleton className={t12} />;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== isUser) {
    t14 = !isUser && <Skeleton className="h-4 w-full max-w-64 rounded" />;
    $[16] = isUser;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t10 || $[19] !== t13 || $[20] !== t14) {
    t15 = <div className="flex min-w-0 flex-col gap-2">{t10}{t13}{t14}</div>;
    $[18] = t10;
    $[19] = t13;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t15 || $[23] !== t7) {
    t16 = <div className={t7}>{t15}</div>;
    $[22] = t15;
    $[23] = t7;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t16 || $[26] !== t2) {
    t17 = <motion.div className={t2} initial={t3} animate={t4} exit={t5} transition={t6}>{t16}</motion.div>;
    $[25] = t16;
    $[26] = t2;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  return t17;
}
export function MessageSkeletonList(t0) {
  const $ = _c(2);
  const {
    count: t1
  } = t0;
  const count = t1 === undefined ? 3 : t1;
  let t2;
  if ($[0] !== count) {
    t2 = <>{Array.from({
        length: count
      }).map(_temp)}</>;
    $[0] = count;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
function _temp(_, i) {
  return <MessageSkeleton key={i} role={i % 2 === 0 ? "user" : "assistant"} className={cn(i > 0 && "mt-6")} />;
}